import { FC } from 'react';

import { AvatarUpload, AvatarUploadRef, Spacing, Typography, red } from 'enable-ui';

import { CustomAvatar } from 'modules/learners/styles/avatar';

import { AvatarContainer } from '../styles/form';

import { ReactComponent as AvatarIcon } from 'assets/icons/avatar.svg';

import { useBoolean } from 'hooks';

import { MAX_FILE_SIZE } from 'constants/avatar';

export const AvatarTrainer: FC<{
  onChangeAvatar: (file: File) => void;
  logoURL: string;
  onDeleteLogo: () => void;
  logoRef: React.RefObject<AvatarUploadRef>;
}> = ({ onChangeAvatar, logoURL, onDeleteLogo, logoRef }) => {
  const isErrorAvatar = useBoolean(false);

  const onErrorAvatar = (file: File) => {
    isErrorAvatar.setValue(Boolean(file));
  };

  return (
    <Spacing spacing="3xl" type="margin" placement="right">
      <CustomAvatar>
        <AvatarUpload
          id="logo-trainer"
          size="lg"
          ref={logoRef}
          accept=".png,.jpeg,.svg,.webp"
          maxFileSize={MAX_FILE_SIZE}
          onError={onErrorAvatar}
          onChangeFile={onChangeAvatar}
          url={logoURL}
          style={{ cursor: 'pointer' }}
        />
        <label htmlFor="logo-trainer">
          <AvatarContainer>
            <AvatarIcon />
          </AvatarContainer>
        </label>
      </CustomAvatar>

      {isErrorAvatar.value && (
        <Typography
          weight={600}
          style={{
            marginTop: 4,
            fontSize: 14,
          }}
          color={red['red-5']}
          variant="body-3"
        >{`Max file size is 10Mb`}</Typography>
      )}
      {logoURL && (
        <Typography
          style={{
            whiteSpace: 'nowrap',
            color: '#FF4D4F',
            fontSize: '16px',
            cursor: 'pointer',
            textAlign: 'center',
            marginTop: 8,
          }}
          onClick={onDeleteLogo}
        >
          Remove
        </Typography>
      )}
    </Spacing>
  );
};
